import { Ref } from 'vue';
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { CommonResType } from '@/types/commonApiType';

import { api } from './_http';

type GetCommentParams = {
	board: string;
	pk: string | number;
};
type GetCommentData = {
	comment_data: CommentData;
	comment_data_count: number;
};
export type CommentData = {
	[key: number]: CommentWithReplies;
};
export type CommentWithReplies = {
	comment: Comment;
	replies?: Comment[];
};
export interface Comment {
	comment_content: number;
	comment_enrollment_date: string;
	comment_pk: number;
	is_mine: string;
	knowhow_pk: string;
	member_nickname: number | null;
	member_pk: number | null;
	notice_pk: string;
	post_pk: string;
	review_pk: string;
	upper_comment_pk: string;
}
export const useGetCommentApi = (params: GetCommentParams) => {
	const url = '/v1/front/getComment';
	return useQuery<AxiosResponse, AxiosError, GetCommentData>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data?.data,
	});
};

export const useGetCommentApiByComputed = (params: Ref<GetCommentParams>) => {
	const url = '/v1/front/getComment';
	return useQuery<AxiosResponse, AxiosError, GetCommentData>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data?.data,
		staleTime: 0,
		gcTime: 0,
	});
};

type SaveCommentParams = {
	board: string;
	knowhow_pk?: number;
	notice_pk?: number;
	master_pk?: number;
	review_pk?: number;
	comment_pk?: number;
	comment_content?: string;
	upper_comment_pk?: number;
};
type SaveCommentResType = CommonResType;
export const useSaveCommentApi = () => {
	const url = '/v1/front/saveComment';
	return useMutation<AxiosResponse<SaveCommentResType>, AxiosError, SaveCommentParams>({
		mutationFn: (data: SaveCommentParams) => api.post(url, data),
	});
};

type DeleteCommentParams = {
	comment_pk: number;
};
export const useDeleteCommentApi = () => {
	const url = '/v1/front/deleteComment';
	const queryClient = useQueryClient();
	return useMutation<AxiosResponse<SaveCommentResType>, AxiosError, DeleteCommentParams>({
		mutationFn: (data: DeleteCommentParams) => api.post(url, data),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['/v1/front/getComment'],
			});
		},
	});
};
